export let calendarMonth_December = "engBSe";
export default {calendarMonth_December};